<div id="formTop" style="margin: 20px" [formGroup]="formGroup" class="efile-page">
  @if (siteConfig.getMncMaintenanceMessage()) {
    <app-banner
      type="error"
      [header]="'Maintenance Mode'"
      [message]="siteConfig.getMncMaintenanceMessage() ?? 'Maintenance Mode'">
    </app-banner>
  } @else {
    <div style="display: flex; flex-direction: column; gap: 10px">

      <!-- Titles -->
      <h1>{{ 'ADS-820.Title' | translate }}</h1>
      <h5>{{ 'ADS-820.Subtitle' | translate }}</h5>

      <!-- Description Paragraphs (using [innerHTML] to preserve bold & links) -->
      <p style="margin-bottom: 0" [innerHTML]="'ADS-820.Description1' | translate"></p>
      <p style="margin-bottom: 0" [innerHTML]="'ADS-820.Description2' | translate"></p>
      <p style="margin-bottom: 0" [innerHTML]="'ADS-820.Description3' | translate"></p>
      <hr>

        <!-- Damaged Property Information Section -->
        <h4>{{ 'ADS-820.DamagedPropertyInfo' | translate }}</h4>
        <div style="display: flex; flex-direction: column; gap: 10px">

          <!-- Damaged Property Address Search -->
          <div style="display: flex; flex-direction: row; gap: 10px; flex-grow: 1">
            <div class="input-group">
              <span class="input-group-text" style="background: lightgray">
                <i class="fas fa-search"></i>
              </span>
              <input
                id="parcel-address-search"
                [formControl]="searchField"
                typeaheadOptionField="SitusStreet"
                [typeahead]="parcels"
                [typeaheadAsync]="true"
                [typeaheadOptionsLimit]="5"
                [optionsListTemplate]="customListTemplate"
                (typeaheadOnSelect)="handleTypeheadOnSelect($event)"
                class="form-control custom-menu"
                [placeholder]="'ADS-820.SitusStreetPlaceholder' | translate"
                />
              </div>

              <button
                class="btn btn-primary btn-assessor"
                style="white-space: nowrap"
                (click)="onClickUseAddress()"
                [ngbTooltip]="useAddressToolTip">
                {{ 'ADS-820.UseAddressButton' | translate }}
              </button>
            </div>

            <!-- Damaged Property Street Address -->
            <div>
              <app-input-label
                controlId="damaged_property_street_address"
                [controlLabel]="'ADS-820.DamagedPropertyStreetAddress' | translate"
                required="true">
              </app-input-label>
              <input
                id="damaged_property_street_address"
                type="text"
                class="form-control"
                [placeholder]="'ADS-820.StreetAddressPlaceholder' | translate"
                formControlName="damaged_property_street_address"
                />
                <app-simple-error-list [control]="formGroup.get('damaged_property_street_address')"></app-simple-error-list>
              </div>

              <!-- Damaged Property City -->
              <div>
                <app-input-label
                  controlId="damaged_property_city"
                  [controlLabel]="'ADS-820.DamagedPropertyCity' | translate"
                  required="true">
                </app-input-label>
                <input
                  id="damaged_property_city"
                  type="text"
                  class="form-control"
                  [placeholder]="'ADS-820.CityPlaceholder' | translate"
                  formControlName="damaged_property_city"
                  />
                  <app-simple-error-list [control]="formGroup.get('damaged_property_city')"></app-simple-error-list>
                </div>

                <!-- Damaged Property Zip -->
                <div>
                  <app-input-label
                    controlId="damaged_property_zip"
                    [controlLabel]="'ADS-820.DamagedPropertyZip' | translate"
                    required="true">
                  </app-input-label>
                  <input
                    id="damaged_property_zip"
                    type="text"
                    class="form-control"
                    [placeholder]="'ADS-820.ZipCodePlaceholder' | translate"
                    formControlName="damaged_property_zip"
                    appNumericSplitter
                    [splitterType]="SplitterType.ZIP"
                    />
                    <app-simple-error-list [control]="formGroup.get('damaged_property_zip')"></app-simple-error-list>
                  </div>
                </div>

                <button
                  class="btn btn-primary btn-assessor"
                  style="white-space: nowrap"
                  (click)="onClickClearAddress()">
                  {{ 'ADS-820.ClearAddress' | translate }}
                </button>

                <hr>
                  <!-- Damaged Property Type -->
                  <h4>
                    {{ 'ADS-820.DamagedPropertyType' | translate }}
                    <span class="color-red">*</span>
                  </h4>
                  <div id="damaged_property_group">

                    <!-- Real Property -->
                    <div id="prop_real_property">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          id="real_property"
                          value="real_property"
                          type="checkbox"
                          formControlName="real_property"
                          />
                          <label class="form-check-label" style="color: black" for="real_property">
                            <b>{{ 'ADS-820.RealProperty' | translate }}</b> {{ 'ADS-820.RealPropertyExtra' | translate }}
                          </label>
                        </div>
                        <div style="margin-left: 20px">
                          <app-input-label
                            controlId="ain"
                            [controlLabel]="'ADS-820.AssessmentNumber' | translate"
                            [required]="false">
                          </app-input-label>
                          <input
                            id="ain"
                            type="text"
                            class="form-control"
                            placeholder="xxxx-xxx-xxx"
                            formControlName="ain"
                            appNumericSplitter
                            [splitterType]="SplitterType.AIN"
                            />
                            <app-simple-error-list [control]="formGroup.get('ain')"></app-simple-error-list>
                          </div>
                        </div>

                        <!-- Boat or Aircraft Property -->
                        <div id="prop_aircraft_boat">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              id="boat_aircraft_property"
                              value="boat_aircraft_property"
                              type="checkbox"
                              formControlName="boat_aircraft_property"
                              />
                              <label class="form-check-label" style="color: black" for="boat_aircraft_property">
                                <b>{{ 'ADS-820.BoatAircraftProperty' | translate }}</b>
                              </label>
                            </div>
                            <div style="margin-left: 20px">
                              <app-input-label
                                controlId="boat_aircraft_property"
                                [controlLabel]="'ADS-820.RegistrationNumber' | translate"
                                [required]="false">
                              </app-input-label>
                              <input
                                id="boat_aircraft_reg"
                                type="text"
                                class="form-control"
                                [placeholder]="'ADS-820.BoatAircraftPlaceholder' | translate"
                                formControlName="boat_aircraft_reg"
                                />
                                <app-simple-error-list [control]="formGroup.get('boat_aircraft_reg')"></app-simple-error-list>
                              </div>
                            </div>

                            <!-- Business Personal Property -->
                            <div id="prop_business_pp">
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  id="business_personal_property"
                                  value="business_personal_property"
                                  type="checkbox"
                                  formControlName="business_personal_property"
                                  />
                                  <label class="form-check-label" style="color: black" for="business_personal_property">
                                    <b>{{ 'ADS-820.BusinessPersonalProperty' | translate }}</b>
                                  </label>
                                </div>
                                <div class="business-pp-group" style="margin-left: 20px">
                                  <div style="flex-grow: 1">
                                    <app-input-label
                                      controlId="assessment_number"
                                      [controlLabel]="'ADS-820.AssessmentNumberBusiness' | translate"
                                      [required]="false">
                                    </app-input-label>
                                    <input
                                      id="assessment_number"
                                      type="text"
                                      class="form-control"
                                      [placeholder]="'ADS-820.Assessment/CompanyPlaceholder' | translate"
                                      formControlName="assessment_number"
                                      />
                                      <app-simple-error-list [control]="formGroup.get('assessment_number')"></app-simple-error-list>
                                    </div>
                                    <div style="flex-grow: 1">
                                      <app-input-label
                                        controlId="company_name"
                                        [controlLabel]="'ADS-820.CompanyName' | translate"
                                        [required]="false">
                                      </app-input-label>
                                      <input
                                        id="company_name"
                                        type="text"
                                        class="form-control"
                                        [placeholder]="'ADS-820.CompanyNamePlaceholder' | translate"
                                        formControlName="company_name"
                                        />
                                        <app-simple-error-list [control]="formGroup.get('company_name')"></app-simple-error-list>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Manufactured Home -->
                                  <div id="prop_manufactured_home">
                                    <div class="form-check">
                                      <input
                                        class="form-check-input"
                                        id="manufactured_property"
                                        value="manufactured_property"
                                        type="checkbox"
                                        formControlName="manufactured_property"
                                        />
                                        <label class="form-check-label" style="color: black" for="manufactured_property">
                                          <b>{{ 'ADS-820.ManufacturedHome' | translate }}</b>
                                        </label>
                                      </div>
                                      <div style="margin-left: 20px">
                                        <app-input-label
                                          controlId="manufactured_home_no"
                                          [controlLabel]="'ADS-820.AssessorIDNumber' | translate"
                                          [required]="false">
                                        </app-input-label>
                                        <input
                                          id="manufactured_home_no"
                                          type="text"
                                          class="form-control"
                                          [placeholder]="'ADS-820.AssessorIDPlaceholder' | translate"
                                          formControlName="manufactured_home_no"
                                          />
                                          <app-simple-error-list [control]="formGroup.get('manufactured_home_no')"></app-simple-error-list>
                                        </div>
                                      </div>
                                    </div>

                                    <!-- Validation message if no property type is selected -->
                                    @if (hasDamagePropSelected === false) {
                                      <ul>
                                        <li style="color: red; margin-left: 20px">
                                          {{ 'ADS-820.PleaseIndicateDamageType' | translate }}
                                        </li>
                                      </ul>
                                    }

                                    <hr>
                                      <!-- Damaged Property Details -->
                                      <h4>{{ 'ADS-820.DamagedPropertyDetails' | translate }}</h4>
                                      <div id="damage-info">
                                        <div style="display: flex; flex-direction: row; gap: 10px">
                                          <!-- Date Damage Occurred -->
                                          <div>
                                            <app-input-label
                                              controlId="date_damage"
                                              [controlLabel]="'ADS-820.DateDamageOccurred' | translate"
                                              [required]="true">
                                            </app-input-label>
                                            <input
                                              id="date_damage"
                                              type="date"
                                              class="form-control"
                                              placeholder="Date damage occurred"
                                              formControlName="date_damage"
                                              />
                                              <app-simple-error-list [control]="formGroup.get('date_damage')"></app-simple-error-list>
                                            </div>

                                            <!-- Date Damage Repaired -->
                                            <div>
                                              <app-input-label
                                                controlId="date_repaired"
                                                [controlLabel]="'ADS-820.DateDamageRepaired' | translate"
                                                [required]="false">
                                              </app-input-label>
                                              <input
                                                id="date_repaired"
                                                type="date"
                                                class="form-control"
                                                placeholder="Date damage repaired"
                                                formControlName="date_repaired"
                                                />
                                              </div>
                                            </div>

                                            <!-- Describe Damage -->
                                            <div>
                                              <app-input-label
                                                controlId="damage_cause"
                                                [controlLabel]="'ADS-820.DescribeDamage' | translate"
                                                [required]="false">
                                              </app-input-label>
                                              <textarea
                                                id="damage_cause"
                                                maxlength="280"
                                                rows="5"
                                                class="form-control"
                                                [placeholder]="'ADS-820.DescriptionPlaceholder' | translate"
                                                formControlName="damage_cause">
                                              </textarea>
                                              <app-simple-error-list [control]="formGroup.get('damage_cause')"></app-simple-error-list>
                                            </div>
                                            <hr>

                                              <!-- Owner/Applicant Information -->
                                              <h4>{{ 'ADS-820.OwnerApplicantInfo' | translate }}</h4>
                                              <div style="display: flex; flex-direction: column; gap: 10px">
                                                <!-- First Name -->
                                                <div>
                                                  <app-input-label
                                                    controlId="first_name"
                                                    [controlLabel]="'ADS-820.FirstName' | translate"
                                                    [required]="true">
                                                  </app-input-label>
                                                  <input
                                                    id="first_name"
                                                    type="text"
                                                    class="form-control"
                                                    [placeholder]="'ADS-820.FirstNamePlaceholder' | translate"
                                                    formControlName="first_name"
                                                    />
                                                    <app-simple-error-list [control]="formGroup.get('first_name')"></app-simple-error-list>
                                                  </div>

                                                  <!-- Last Name -->
                                                  <div>
                                                    <app-input-label
                                                      controlId="last_name"
                                                      [controlLabel]="'ADS-820.LastName' | translate"
                                                      [required]="true">
                                                    </app-input-label>
                                                    <input
                                                      id="last_name"
                                                      type="text"
                                                      class="form-control"
                                                      [placeholder]="'ADS-820.LastNamePlaceholder' | translate"
                                                      formControlName="last_name"
                                                      />
                                                      <app-simple-error-list [control]="formGroup.get('last_name')"></app-simple-error-list>
                                                    </div>

                                                    <!-- Email (hardcoded label or add a key in JSON if desired) -->
                                                    <div>
                                                      <app-input-label
                                                        controlId="signer1_email"
                                                        controlLabel="Email"
                                                        [required]="true">
                                                      </app-input-label>
                                                      <input
                                                        id="email"
                                                        type="email"
                                                        class="form-control"
                                                        [placeholder]="'ADS-820.EmailPlaceholder' | translate"
                                                        formControlName="signer1_email"
                                                        />
                                                        <app-simple-error-list [control]="formGroup.get('signer1_email')"></app-simple-error-list>
                                                      </div>

                                                      <!-- Phone (hardcoded label or add a key in JSON if desired) -->
                                                      <div>
                                                        <app-input-label
                                                          controlId="signer1_phone"
                                                          [controlLabel]="'ADS-820.PhonePlaceholder' | translate"
                                                          [required]="true">
                                                        </app-input-label>
                                                        <input
                                                          id="phone"
                                                          type="text"
                                                          class="form-control"
                                                          [placeholder]="'ADS-820.PhonePlaceholder' | translate"
                                                          formControlName="signer1_phone"
                                                          appNumericSplitter
                                                          [splitterType]="SplitterType.PHONE"
                                                          />
                                                          <app-simple-error-list [control]="formGroup.get('signer1_phone')"></app-simple-error-list>
                                                        </div>
                                                      </div>
                                                      <hr>

                                                        <!-- Current Mailing Address (not in JSON, so left as is) -->
                                                        <h4>{{ 'ADS-820.CurrentMailingAddress' | translate }}</h4>
                                                        <p [innerHTML]="'ADS-820.CurrentMailingAddressDesc' | translate"></p>
                                                        <div style="display: flex; flex-direction: column; gap: 10px">
                                                          <div>
                                                            <app-input-label
                                                              controlId="mail_street_address"
                                                              [controlLabel]="'ADS-820.MailingStreetAddress' | translate"
                                                              [required]="true">
                                                            </app-input-label>
                                                            <input
                                                              id="mail_street_address"
                                                              type="text"
                                                              class="form-control"
                                                              [placeholder]="'ADS-820.StreetAddressPlaceholder' | translate"
                                                              formControlName="mail_street_address"
                                                              />
                                                              <app-simple-error-list [control]="formGroup.get('mail_street_address')"></app-simple-error-list>
                                                            </div>
                                                            <div>
                                                              <app-input-label
                                                                controlId="mail_city"
                                                                [controlLabel]="'ADS-820.MailingAddressCity' | translate"
                                                                [required]="true">
                                                              </app-input-label>
                                                              <input
                                                                id="mail_city"
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="City"
                                                                [placeholder]="'ADS-820.CityPlaceholder' | translate"
                                                                formControlName="mail_city"
                                                                />
                                                                <app-simple-error-list [control]="formGroup.get('mail_city')"></app-simple-error-list>
                                                              </div>
                                                              <div>
                                                                <app-input-label
                                                                  controlId="mail_state"
                                                                  [controlLabel]="'ADS-820.MailingAddressState' | translate"
                                                                  [required]="true">
                                                                </app-input-label>
                                                                <input
                                                                  id="mail_state"
                                                                  type="text"
                                                                  class="form-control"
                                                                  [placeholder]="'ADS-820.StatePlaceholder' | translate"
                                                                  formControlName="mail_state"
                                                                  />
                                                                  <app-simple-error-list [control]="formGroup.get('mail_state')"></app-simple-error-list>
                                                                </div>
                                                                <div>
                                                                  <app-input-label
                                                                    controlId="mail_zip"
                                                                    [controlLabel]="'ADS-820.MailingAddressZip' | translate"
                                                                    [required]="true">
                                                                  </app-input-label>
                                                                  <input
                                                                    id="mail_zip"
                                                                    type="text"
                                                                    class="form-control"
                                                                    [placeholder]="'ADS-820.ZipCodePlaceholder' | translate"
                                                                    formControlName="mail_zip"
                                                                    appNumericSplitter
                                                                    [splitterType]="SplitterType.ZIP"
                                                                    />
                                                                    <app-simple-error-list [control]="formGroup.get('mail_zip')"></app-simple-error-list>
                                                                  </div>
                                                                </div>
                                                                <hr>

                                                                  <!-- Optional Supporting Documentation -->
                                                                  <h4>{{ 'ADS-820.OptionalSupportingDocumentationTitle' | translate }}</h4>
                                                                  <p style="color: black">
                                                                    {{ 'ADS-820.OptionalSupportingDocumentationDescription' | translate }}
                                                                  </p>
                                                                  <app-file-upload-v2 [fileControl]="fileUploadControl"></app-file-upload-v2>
                                                                  <hr>

                                                                    <!-- Submission Section -->
                                                                    @switch (submissionStatus) {
                                                                      <!-- Waiting -->
                                                                      @case (AdsSubmissionStatus.waiting) {
                                                                        <div>
                                                                          <div class="centered-content">
                                                                            <h4 style="text-align: center">{{ 'ADS-820.SubmitTitle' | translate }}</h4>
                                                                            <p style="color: black; text-align: center">
                                                                              {{ 'ADS-820.SubmitDescription' | translate }}
                                                                            </p>
                                                                            @if (error) {
                                                                              <p style="text-align: center">
                                                                                {{ 'ADS-820.SubmitError' | translate }}
                                                                              </p>
                                                                            }
                                                                            <div style="display: flex; flex-direction: column; gap: 10px">
                                                                              <div>
                                                                                <app-input-label
                                                                                  controlId="signature1"
                                                                                  [controlLabel]="'ADS-820.TypeFullLegalNamePlaceholder' | translate"
                                                                                  [required]="true">
                                                                                </app-input-label>
                                                                                <input
                                                                                  id="signature"
                                                                                  type="text"
                                                                                  class="form-control"
                                                                                  [placeholder]="'ADS-820.FirstLastPlaceholder' | translate"
                                                                                  formControlName="signature1"
                                                                                  />
                                                                                  @if (hasSigned === false) {
                                                                                    <ul>
                                                                                      <li style="color: red; margin-left: 20px">
                                                                                        {{ 'ADS-820.SignatureError' | translate }}
                                                                                      </li>
                                                                                    </ul>
                                                                                  }
                                                                                </div>
                                                                                <button
                                                                                  class="btn btn-primary btn-submit"
                                                                                  style="white-space: nowrap"
                                                                                  (click)="onClickSubmit(errorSubmission)"
                                                                                  [disabled]="environmentService.isQA() && enableSubmission !== true">
                                                                                  {{ 'ADS-820.SubmitButton' | translate }}
                                                                                </button>
                                                                                <button
                                                                                  class="btn btn-primary btn-assessor"
                                                                                  style="white-space: nowrap"
                                                                                  (click)="onClickPreview(pdfPreviewPopUp)">
                                                                                  {{ 'ADS-820.PreviewButton' | translate }}
                                                                                </button>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        }
                                                                        <!-- Submitting -->
                                                                        @case (AdsSubmissionStatus.submitting) {
                                                                          <div>
                                                                            <div class="centered-content">
                                                                              <h4 style="text-align: center">
                                                                                {{ 'ADS-820.SubmissionInProgressTitle' | translate }}
                                                                              </h4>
                                                                              <p style="color: black; text-align: center">
                                                                                {{ 'ADS-820.SubmissionInProgressMessage' | translate }}
                                                                              </p>
                                                                              <div style="display: flex; justify-content: center; align-content: center">
                                                                                <app-loading-spinner></app-loading-spinner>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        }
                                                                        <!-- Submitted -->
                                                                        @case (AdsSubmissionStatus.submitted) {
                                                                          <div>
                                                                            <div class="centered-content">
                                                                              <h4 style="text-align: center">
                                                                                {{ 'ADS-820.SubmissionSuccessTitle' | translate }}
                                                                              </h4>
                                                                              <p style="color: black; text-align: center">
                                                                                {{ 'ADS-820.SubmissionSuccessMessage' | translate }}
                                                                              </p>
                                                                              <button
                                                                                class="btn btn-primary btn-assessor"
                                                                                style="white-space: nowrap"
                                                                                (click)="onStartNewSubmission()">
                                                                                {{ 'ADS-820.StartNewSubmissionButton' | translate }}
                                                                              </button>
                                                                            </div>
                                                                          </div>
                                                                        }
                                                                      }
                                                                    </div>
                                                                  </div>
                                                                }
                                                              </div>

                                                              <!-- Error Submission Modal -->
                                                              <ng-template #errorSubmission>
                                                                <div style="display: flex; flex-direction: column; padding: 10px; gap: 5px; background: ghostwhite">
                                                                  <h1 style="text-align: center">
                                                                    {{ 'ADS-820.FormErrorsTitle' | translate }}
                                                                  </h1>
                                                                  <p>
                                                                    {{ 'ADS-820.FormErrorsMessage' | translate }}
                                                                  </p>
                                                                  <button class="btn btn-primary btn-assessor" (click)="modalRef.hide()">
                                                                    {{ 'ADS-820.CloseButton' | translate }}
                                                                  </button>
                                                                </div>
                                                              </ng-template>

                                                              <!-- PDF Preview Modal -->
                                                              <ng-template #pdfPreviewPopUp>
                                                                <div style="display: flex; flex-direction: column; padding: 10px; gap: 5px; background: ghostwhite">
                                                                  <app-form-preview [pdfFillJson]="pdfFillJson()"></app-form-preview>
                                                                  <button class="btn btn-primary btn-assessor" (click)="modalRef.hide()">Close Preview</button>
                                                                </div>
                                                              </ng-template>

                                                              <!-- Custom Typeahead List Template -->
                                                              <ng-template #customListTemplate let-matches="matches" let-query="query" let-typeaheadTemplateMethods>
                                                                <ul class="custom-list-group">
                                                                  @for (match of matches; track match) {
                                                                    <li
                                                                      class="custom-list-group-item"
                                                                      [class.active]="typeaheadTemplateMethods.isActive(match)"
                                                                      (click)="typeaheadTemplateMethods.selectMatch(match, $event)"
                                                                      (mouseenter)="typeaheadTemplateMethods.selectActive(match)">
                                                                      {{ match.item.SitusStreet + ', ' + match.item.SitusCity + ', ' + match.item.SitusZipCode }}
                                                                    </li>
                                                                  }
                                                                </ul>
                                                              </ng-template>
